export function extentionCategory(id: string): boolean {
  let resultBool = true;
  switch (id) {
    case 'P9hcqg1j_bJDTtVA':
    case 'r7rC4K6hoPycJ0Gz':
    case 'qVNHW5pY8HZjbHKM':
    case 'Tvj1HF6vcvSgXPo-':
    case '7g6LZsi0qBwLP5K1':
    case 'VVpX9YkX7hcxsMdE':
    case 'nO8efugcVGoFZWQb':
    case 'i3OS02dLW4eb_jj1':
    case 'x7X38suGrP9dcQiU':
    case 'DR4RZkbr_ZNsoltq':
    case 'lQP6eIqBBbi6G_1Q':
    case 'Nh8o32qxIXXqXR_O':
    case 'wprZm-glvDkO8enM':
    case 'iB9i8IjMv519AEb3':
    case '18Mm87u5V0hU6B57':
    case 'WvA7mOd2zVCpgjSC':
    case 'o11lpOrtYZvft2kS':
    case 'YCs71D_HpHuzaIn-':
    case 'vKPAt48Z82J--OQW':
    case 'yn77N1jwEoadGi9k':
    case 'dyU762lu6RonOLhT':
    case 'Cb1rlUxvKLutuFyT':
    case 'C1GN6X0nwhF9y4m-':
    case 'rH76pcPI7w89wgFB':
    case '9x2g5R-9DMQMAHSX':
      resultBool = false;
      break;
    default:
      resultBool = true;
      break;
  }
  return resultBool;
}
